module.exports = __webpack_public_path__ + "static/media/feedbackIcon.fbd8c125.png";